import 'css-chunksrc/client/scenes/projectsTransfer/projectsList/styles.scss';export default {
  "projectsList": "_projectsList_1wan7_1",
  "heading": "_heading_1wan7_5",
  "list": "_list_1wan7_11",
  "item": "_item_1wan7_19",
  "label": "_label_1wan7_25"
};